export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20modern%20lifestyle%20photography%20featuring%20diverse%20fashion%20and%20accessory%20products%20including%20sneakers%20bags%20and%20clothing%20artistically%20scattered%20on%20light%20grey%20concrete%20surface%20with%20dramatic%20side%20lighting%20from%20large%20window%20creating%20bold%20shadows%20editorial%20high%20contrast%20composition%20professional%20product%20photography&width=1600&height=900&seq=hero-v2-2026-x01&orientation=landscape"
          alt="itaobuy sheet product sourcing showcase"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 max-w-[900px] mx-auto text-center pt-16">
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-4">
          Itaobuy Sheet
        </h1>
        <p className="font-heading text-2xl md:text-3xl lg:text-4xl text-background-100 font-medium italic mb-6">
          The Smartest Way to Buy from China in 2026
        </p>
        <p className="text-base md:text-lg text-background-200/90 max-w-[680px] mx-auto leading-relaxed mb-10">
          Discover how the <strong>itaobuy spreadsheet</strong> system simplifies sourcing, ordering, and shipping products from China with lower cost, higher efficiency, and full transparency.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-foreground-950 text-background-50 text-sm md:text-base font-semibold cursor-pointer hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap"
          >
            itaobuy sheet
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line"></i>
            </span>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-transparent border border-background-50/60 text-background-50 text-sm md:text-base font-semibold cursor-pointer hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap"
          >
            buy it now
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shopping-bag-line"></i>
            </span>
          </a>
        </div>

        <p className="mt-8 text-xs md:text-sm text-background-300/80">
          Trusted by global buyers, resellers, and sourcing agents
        </p>
      </div>
    </section>
  );
}